module.exports = __webpack_public_path__ + "img/fair-expiry-date.24e49cf8.png";